/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables = {
    readonly itemId?: string | null;
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly status: string | null;
            readonly pricing: {
                readonly bargain: unknown | null;
            } | null;
        } | null;
    } | null;
};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery = {
    readonly response: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse;
    readonly variables: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String",
            "defaultValue": ""
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "itemId",
            "variableName": "itemId"
        } as any),
        ({
            "kind": "Literal",
            "name": "pageType",
            "value": "PDP"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pricing",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPricing",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "bargain",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        },
                        (v4 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'd70eebf5fdb8a4e24d9b72690c4db735';
export default node;
